import { motion } from "framer-motion";
import Capability from "../components/Capability";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import AboutImg from "../assets/about.jpeg";
import AboutSmall from "../assets/aboutSmall.jpg";
import Orpetron from "../assets/orpetron.png";

const About = () => {
  return (
    <>
      <motion.div
        className="about"
        initial={{ opacity: 0, z: 100 }}
        animate={{ opacity: 1, z: 0 }}
        exit={{ opacity: 0, z: -100 }}
        transition={{ duration: 1, delay: 0.75 }}
      >
        <div className="about-heading">
          <Banner text="About" />
        </div>
        <div className="about-top">
          <div className="about-top-left">
            <motion.p
              initial={{
                opacity: 0,
                transform: "scale(1.01)",
              }}
              whileInView={{
                opacity: 1,
                transform: "scale(1.02)",
              }}
              transition={{ duration: 0.5, delay: 0.15 }}
            >
              I have always been fascinated by the <span>how</span>. It’s
              through this fascination, combined with my skills in design,
              development, and interactions that I help brands, companies and
              organizations bring their digital identities to life.
            </motion.p>
          </div>
          <div className="about-top-right">
            <motion.img
              src={AboutImg}
              alt=""
              initial={{
                opacity: 0,
              }}
              whileInView={{
                opacity: 1,
              }}
              transition={{
                ease: [0.6, 0.01, -0.05, 0.9],
                duration: 0.5,
                delay: 0.15,
              }}
            />
          </div>
        </div>
        <motion.div
          className="about-capabilities"
          initial={{
            opacity: 0,
            transform: "scale(1.01)",
          }}
          whileInView={{
            opacity: 1,
            transform: "scale(1.02)",
          }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <h3>What i do</h3>
          <div className="capabilities">
            <div className="capabilities-wrapper">
              <Capability />
            </div>
          </div>
        </motion.div>
        <motion.div
          className="about-bottom"
          initial={{
            opacity: 0,
            transform: "scale(1.01)",
          }}
          whileInView={{
            opacity: 1,
            transform: "scale(1.02)",
          }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <div className="about-bottom-left">
            <motion.img
              src={AboutSmall}
              alt=""
              initial={{
                opacity: 0,
              }}
              whileInView={{
                opacity: 1,
              }}
              transition={{
                ease: [0.6, 0.01, -0.05, 0.9],
                duration: 0.5,
                delay: 0.15,
              }}
            />
          </div>
          <div className="about-bottom-right">
            <motion.img
              src={Orpetron}
              alt=""
              initial={{
                opacity: 0,
              }}
              whileInView={{
                opacity: 1,
              }}
              transition={{
                ease: [0.6, 0.01, -0.05, 0.9],
                duration: 0.5,
                delay: 0.15,
              }}
            />
            <h3>
              Orpetron Awards
              <br />
              Judge '22 -
            </h3>
            <p>
              As a proud member of the Orpetron International Jury, I help
              select the best of the best in the world of design and
              development.
            </p>
          </div>
        </motion.div>
      </motion.div>
      <motion.div
        className="page-bottom-sections"
        initial={{
          opacity: 0.75,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        }}
        whileInView={{
          opacity: 1,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
        }}
        transition={{ duration: 0.5 }}
      >
        <Footer />
      </motion.div>
    </>
  );
};

export default About;
